/* src/app/components/burger-btn/burger-btn.component.scss */
:host.absolute-position {
  position: absolute;
  top: -11px;
}
ion-button {
  --background: transparent;
  margin-right: -20px;
  --box-shadow: none;
  border: none;
  --border-style: none;
}
ion-button ion-icon {
  height: 35px;
  width: 30px;
}
@media (min-width: 991px) {
  ion-button ion-icon {
    height: 16px;
    width: 33px;
  }
}
/*# sourceMappingURL=burger-btn.component.css.map */
